import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CalendarCheckIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function StickyCta() {
  const {
    hasChosen,
    t
  } = useLanguage();
  const [scrolledPastHero, setScrolledPastHero] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolledPastHero(window.scrollY > 700);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const visible = hasChosen && scrolledPastHero;
  return <AnimatePresence data-id="element-358" data-mp="3gj4dzde3pe2g">
      {visible}
    </AnimatePresence>;
}